var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from '~/core/decorator';
var FlowTaskService = /** @class */ (function () {
    function FlowTaskService() {
    }
    /**
     * 查看审批流
     */
    FlowTaskService.prototype.getFlowTask = function (data) {
        return this.netService.send({
            server: domainService.flowTaskController.getFlowTask,
            data: data,
        });
    };
    /**
     * 增加审批流
     */
    FlowTaskService.prototype.addFlowTask = function (data) {
        return this.netService.send({
            server: domainService.flowTaskController.addFlowTask,
            data: data,
        });
    };
    /**
     * 修改审批流状态
     */
    FlowTaskService.prototype.modifyFlowTask = function (data) {
        return this.netService.send({
            server: domainService.flowTaskController.putFlowTask,
            append: 'status',
            data: data,
        });
    };
    /**
     * 更新审批流
     */
    FlowTaskService.prototype.updateFlowTask = function (data) {
        return this.netService.send({
            server: domainService.flowTaskController.putFlowTask,
            append: ['update'],
            data: data,
        });
    };
    /**
     * 审批流列表
     */
    FlowTaskService.prototype.queryFlowTask = function (data, page, sort) {
        return this.netService.send({
            server: domainService.flowTaskController.queryFlowTask,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 审批类型设置列表
     */
    FlowTaskService.prototype.queryApplyCategory = function (data, page, sort) {
        return this.netService.send({
            server: domainService.flowTaskController.queryApplyCategory,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 修改审批类型设置状态
     */
    FlowTaskService.prototype.applyCategory = function (data) {
        return this.netService.send({
            server: domainService.flowTaskController.applyCategory,
            append: 'status',
            data: data,
        });
    };
    /**
     * 审批类型设置列表
     */
    FlowTaskService.prototype.checkApplyCategory = function (data) {
        return this.netService.send({
            server: domainService.flowTaskController.checkApplyCategory,
            data: data,
        });
    };
    __decorate([
        Inject(NetService)
    ], FlowTaskService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], FlowTaskService.prototype, "addFlowTask", null);
    __decorate([
        Debounce()
    ], FlowTaskService.prototype, "modifyFlowTask", null);
    __decorate([
        Debounce()
    ], FlowTaskService.prototype, "updateFlowTask", null);
    __decorate([
        Debounce()
    ], FlowTaskService.prototype, "applyCategory", null);
    return FlowTaskService;
}());
export { FlowTaskService };
